module.exports = __webpack_public_path__ + "static/media/crypto.c48dd0f3.svg";